import { RouteRecordRaw } from "vue-router";
const FinancialCenterList: RouteRecordRaw = {
  path: "financialCenterList",
  component: () => import("@/views/accounts/index.vue"),
  meta: {
    title: "FinancialCenterList"
  },
  children: [
    {
      path: "",
      alias: "index",
      name: "financialCenterList",
      component: () =>
        import("@/views/accounts/financialCenterList/pages/index.vue"),
      meta: {
        pageId: 17010500,
        role: "view",
        title: "FinancialCenterList"
      },
    },
  ],
};

export default FinancialCenterList;
